export default function Hero() {
  const stats = [
    { value: '100+', label: '每日更新剧集' },
    { value: '全平台', label: '安卓/iOS通用' },
    { value: '千万级', label: '用户信赖之选' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left pt-8 lg:pt-0">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
              全网热门影视
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              91影视看片app
              <span className="block text-primary-600 text-xl md:text-3xl lg:text-4xl mt-1">
                免费高清影视平台
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 mb-3 font-medium">
              随时随地，高清看片不缓冲
            </p>

            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto lg:mx-0 leading-relaxed mb-6">
              91影视看片app是一款覆盖安卓与苹果双平台的免费影视应用，汇聚海量高清影视资源，涵盖热门电影、电视剧、综艺、动漫等内容。每日持续更新最新剧集，支持离线缓存与多清晰度切换，让您随时随地畅享流畅观影体验，告别卡顿与缓冲烦恼。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-lg md:text-xl font-heading font-bold text-primary-600">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium whitespace-nowrap rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all cursor-pointer no-underline"
              >
                <i className="ri-download-cloud-2-line"></i>立即下载安装
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium whitespace-nowrap rounded-full border border-foreground-200 text-foreground-700 hover:bg-background-100 transition-all cursor-pointer no-underline"
              >
                <i className="ri-information-line"></i>了解更多功能
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[520px] md:w-[320px] md:h-[560px]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20a%20sleek%20movie%20streaming%20app%20interface%20with%20colorful%20film%20posters%20arranged%20in%20a%20grid%20layout%2C%20dark%20theme%20UI%20with%20warm%20gold%20accents%2C%20play%20buttons%20on%20posters%2C%20category%20navigation%20tabs%20at%20top%2C%20trending%20movies%20section%2C%20minimalist%20and%20premium%20app%20design%2C%20soft%20shadow%2C%20isolated%20on%20light%20warm%20background&width=640&height=1120&seq=hero-phone-app-01&orientation=portrait"
                alt="91影视看片app手机界面展示"
                className="w-full h-full object-contain object-top"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}